/** The API accepts repeated otpremnica fields in one receipt transaction. */
export function appendReceiptAttachments(body: FormData, files: File[]) {
  for (const file of files) body.append("otpremnica", file, file.name);
}
